<template>
  <div>
    <baidu-map
      class="map"
      :center="{ lng: 112.910684, lat: 28.202014 }"
      :zoom="17"
      :scroll-wheel-zoom="true"
    >
      <bm-marker
        :position="{ lng: 112.910684, lat: 28.202014 }"
        :dragging="true"
        @click="openBaiduMap"
      ></bm-marker>
    </baidu-map>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    openBaiduMap() {
      window.location.href =
        "http://api.map.baidu.com/geocoder?address=湖南省长沙市岳麓区天顶街道环湖路 1177号方茂苑（二期）12、13、15栋1916室&output=html&src=webapp.baidu.openAPIdemo";
    },
  },
};
</script>

<style lang="scss" scoped>
.map {
  height: 251px;
  width: 100%;
  margin: auto;
}
.marker {
  div:nth-child(1) {
    color: rgb(238, 93, 10);
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
  }
}
</style>
